// --- 订单管理 --- //

export default [
  {
    name: 'orderManagement',
    path: '/carWashSuperviseSystem/:carWashId/orderManagement',
    meta: { title: '订单管理' },
    component: require('business/carWashSuperviseSystem/orderManagement/list.vue').default
  }
]
